<div class="tag-nav">
  @if (navItems) {
    @for(link of navItems; track link.id) {
      <a class="tag-link" [ngClass]="link.assignedClasses" (click)="tagSelectedEvent(link)">{{link.name}}</a>
    }
  }
</div>
